<script>
/* eslint-disable semi */
import { Component } from 'vue-property-decorator';
import AppCascader from './AppCascader';

@Component
export default class AppDynamicCascader extends AppCascader {
  /**
   * 拡張設定
   * api.paramName: APIへ付与するパラメータ名
   * api.options: オプション値を取得するAPIのURL
   * api.hierarchy: コード値を階層構造に変換するAPIのURL
   */

  /**
   * 選択オプションの動的ローディング有無
   */
  get isDynamicLoadingCascader () {
    return true;
  }

  /**
   * フィルター入力可否
   */
  get filterable () {
    return false;
  }

  /**
   * フィルター入力可否
   */
  get changeOnSelect () {
    return false;
  }

  /**
   * 選択値を取得する
   */
  fetchOptionsImpl (hierarchy) {
    const cache = (this.options.global) ? this.$_sas.$cache.global : this.$_sas.$cache;
    const url = this.options.api.options;
    const params = {};
    if (hierarchy.length > 0) {
      params[this.options.api.paramName] = hierarchy[hierarchy.length - 1];
    }

    return cache
      .segment(url)
      .get(params, () => {
        return this.$_sas.$api.segment('options').cancel().get(url, { params })
          .then(response => {
            return response.data.results.codes;
          });
      });
  }

  /**
   * コードに対応するコード階層配列をサーバから取得する
   *
   * NOTE
   * 動的ローディングを利用する場合には、コード階層配列をサーバから取得するよう
   * オーバーライドする必要がある。
   */
  fetchHierarchyImpl (value) {
    const url = this.options.api.hierarchy;
    const params = {};
    params[this.options.api.paramName] = value;

    return this.$_sas.$cache
      .segment(url)
      .get(params, () => {
        return this.$_sas.$api.segment('hierarchy').cancel().get(url, { params })
          .then(response => {
            return response.data.results.codes;
          });
      });
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/cascader/AppDynamicCascader.vue